"use client";
import * as React from "react";
import { useEffect } from "react";
import * as CookieConsent from "vanilla-cookieconsent";
import getConfig from "./CookieConsentConfig";

const ResetCookieConsent = () => {
  CookieConsent.reset(true);
  CookieConsent.run(getConfig());
};

const CookieConsentComponent = () => {
  useEffect(() => {
    CookieConsent.run(getConfig());
  }, []);

  return (
    <div style={{margin: '0 auto', textAlign: 'center', fontSize: '0.85rem'}}>
      <a href="#" onClick={CookieConsent.showPreferences}>
        Manage cookie preferences
      </a>
      {" | "}
      <a href="#" onClick={ResetCookieConsent}>
        Reset cookie consent
      </a>
    </div>
  );
};
export default CookieConsentComponent;
